import { ProductCard } from "@commerce-core/react-components";
import CheckIcon from "../assets/check.svg";
import CrossIcon from "../assets/cross.svg";
import Prize1 from "../assets/prize1.webp";
import Prize2 from "../assets/prize2.webp";
import Prize3 from "../assets/prize3.webp";
import Prize4 from "../assets/prize4.webp";
import Prize5 from "../assets/prize5.webp";

type ProductCardsSection = {
  tr_heading?: string;
  tr_subheading?: string;
  products?: ProductCardItem[];
  tr_product_pro_label?: string;
  tr_product_cons_label?: string;
};

export type ProductCardItem = {
  brand_name?: string;
  cta_link?: string;

  price?: string | number;
  rating?: string | number;

  product_image?: {
    url?: string;
  } | null;

  feature_rating?: {
    tr_feature?: string;
    feature_rating?: number | string | null;
  }[];

  pros?: {
    tr_pro?: string;
  }[];

  cons?: {
    tr_con?: string;
  }[];

  main_product?: boolean;

  tr_overall_rating?: string;
  overtall?: number | string;
  stars_rating?: number | string;

  tr_over_ratings?: string;

  tr_cta_label?: string;
  new_tab?: boolean;

  tr_review_heading?: string;
  tr_review?: string;
};

type Props = {
  section?: ProductCardsSection;
};

export default function ProductCards({ section }: Props) {
  if (!section) return null;

  const productCardAssets = {
    prizes: [Prize1, Prize2, Prize3, Prize4, Prize5],
    icons: {
      check: CheckIcon,
      cross: CrossIcon,
    },
  };

  const heading = section.tr_heading;
  const subheading = section.tr_subheading;
  const products = section.products ?? [];

  return (
    <section className="w-full bg-[#fbfbfb] py-8">
      <div className="mx-auto max-w-[972px] p-3 lg:p-0">
        {heading && (
          <div className="mx-auto mt-10 max-w-[910px] rounded-lg bg-[rgb(0,170,242)] py-4 text-center">
            <h2 className="text-[35px] font-bold text-white">{heading}</h2>
          </div>
        )}

        {subheading && (
          <p className="mx-auto mt-4 max-w-[708px] text-center text-[17px] text-[#484848] break-words">
            {subheading}
          </p>
        )}

        <div className="grid gap-[60px]" id="top5">
          {products &&
            products.map((item, index) => (
              <ProductCard
                assets={productCardAssets}
                key={index}
                item={item}
                index={index}
                labels={{
                  tr_product_pro_label: section.tr_product_pro_label,
                  tr_product_cons_label: section.tr_product_cons_label,
                }}
              />
            ))}
        </div>
      </div>
    </section>
  );
}
